/**
 * @file AppLayout 相关工具函数
 */
import { getReactNodeInnerText } from '@seiue/util';
/**
 * Type guard that narrows MenuType down to MenuGroup
 */
export function isMenuGroup(menu) {
    return !!menu.subMenus;
}
/**
 * 检测菜单是否为已激活菜单
 * @param menu
 * @param keys
 */
export function isActiveMenu(menu, keys) {
    if (!(keys === null || keys === void 0 ? void 0 : keys.length))
        return false;
    if (keys.includes(getMenuKey(menu))) {
        return true;
    }
    if (isMenuGroup(menu)) {
        return menu.subMenus.some(child => isActiveMenu(child, keys));
    }
    return false;
}
/**
 * 获取激活菜单全部路径
 * @param menus 侧边栏所有菜单
 * @param activeMenuPath 当前激活的菜单
 */
export function getMenuAbsolutePath(menus, activeMenuPath) {
    let result = [];
    const traverse = (_menus, path) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const menu of _menus) {
            path.push(menu);
            if ('path' in menu && menu.path === activeMenuPath) {
                result = [...path];
                return;
            }
            if (isMenuGroup(menu))
                traverse(menu.subMenus, path);
            path.pop();
        }
    };
    traverse(menus, []);
    return result;
}
/**
 * 获取 menu 的 eventKey
 * @param menu
 */
export function getMenuKey(menu) {
    return !isMenuGroup(menu)
        ? menu.path
        : menu.labelText || getReactNodeInnerText(menu.label);
}
/**
 * 按百分比获取屏幕宽度
 * @param percent
 */
export function getScreenReallyHeightByPercentage(percent) {
    const { clientHeight: docHeight } = document.body;
    return Math.ceil(docHeight * (percent / 100));
}
//# sourceMappingURL=data:application/json;base64,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